import MicroModal from 'micromodal';
import { lenis } from './Scroll';

// ============================================
// ヘッダー追従
// ============================================

function fixedHeader() {
  const header = document.querySelector('.js-header');
  const hero = document.querySelector('.js-hero');
  if (!header || !hero) return;

  let headerH = header.clientHeight;
  let heroH = hero.clientHeight;

  // リサイズで高さが変わるため再計測する
  window.addEventListener(
    'resize',
    () => {
      headerH = header.clientHeight;
      heroH = hero.clientHeight;
    },
    { passive: true }
  );

  window.addEventListener(
    'scroll',
    () => {
      const scrollH = window.scrollY;
      if (scrollH > heroH) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
        header.classList.toggle('is-hidden', scrollH > headerH);
      }
    },
    { passive: true }
  );
}

// ============================================
// 黒背景セクション上のヘッダーロゴ切り替え
// ============================================
function switchHeaderLogo() {
  const header = document.querySelector('.js-header');
  const logo = header?.querySelector('.l-header__logo-link img');
  if (!header || !logo) return;

  const defaultSrc = logo.getAttribute('src');
  const whiteSrc = defaultSrc?.replace(/logo\.svg(\?.*)?$/, 'logo-white.svg$1');
  if (!defaultSrc || !whiteSrc || defaultSrc === whiteSrc) return;

  const updateLogo = () => {
    const shouldUseWhiteLogo =
      header.classList.contains('is-bg-black') &&
      !header.classList.contains('is-mega-open') &&
      !header.classList.contains('is-open');
    const nextSrc = shouldUseWhiteLogo ? whiteSrc : defaultSrc;

    if (logo.getAttribute('src') !== nextSrc) {
      logo.setAttribute('src', nextSrc);
    }
  };

  const observer = new MutationObserver(updateLogo);
  observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  updateLogo();
}

// ============================================
// drawer ハンバーガー開閉処理
// ============================================
function drawer() {
  MicroModal.init();

  //mediaqueryでハンバーガー実装
  const header = document.querySelector('.js-header');
  const hamburger = document.querySelector('.js-drawer-hamburger');
  const navigation = document.querySelector('.js-drawer-navigation');
  // const txt = document.querySelector('.js-drawer-hamburger__txt');
  if (!hamburger || !navigation) {
    return;
  }

  const menuWrap = navigation.querySelector('.l-drawer__nav');
  const menu = navigation.querySelector('.l-drawer__list');
  const wideHamburger = getComputedStyle(document.documentElement).getPropertyValue('--wide-hamburger').trim();
  const hamburgerBreakPoint = getComputedStyle(document.documentElement).getPropertyValue('--hamburger-breakpoint').trim();
  const mediaQuery = window.matchMedia(`(max-width: ${hamburgerBreakPoint})`);

  if (!menu || !menuWrap) return;

  // メニュー内のスクロールが背面に伝播しないようにする(登録は一度だけ)
  const stopPropagation = (e) => e.stopPropagation();

  if (wideHamburger === 'false') {
    menuWrap.addEventListener('wheel', stopPropagation);
    menuWrap.addEventListener('touchmove', stopPropagation);

    const switchMenu = (mq) => {
      if (mq.matches) {
        hamburger.addEventListener('click', hamburgerClick);
        navigation.setAttribute('aria-hidden', true);
      } else {
        navigation.querySelectorAll('a, button').forEach((el) => {
          el.blur();
        });
        navigation.setAttribute('aria-hidden', true);
        lenis.start();
        if (hamburger.classList.contains('is-open')) {
          closeState();
        }
        hamburger.removeEventListener('click', hamburgerClick);
      }
    };

    switchMenu(mediaQuery);
    mediaQuery.addEventListener('change', switchMenu);
  } else {
    hamburger.addEventListener('click', hamburgerClick);
    if (wideHamburger === 'true') {
      menuWrap.addEventListener('wheel', stopPropagation);
      menuWrap.addEventListener('touchmove', stopPropagation);
    }
    navigation.setAttribute('aria-hidden', true);
  }

  // 閉じた状態の見た目に揃える
  function closeState() {
    header?.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    hamburger.ariaExpanded = 'false';
  }

  //ハンバーガークリック関数
  function hamburgerClick() {
    const isOpen = navigation.getAttribute('aria-hidden') === 'false';
    hamburger.ariaExpanded = String(!isOpen);

    if (isOpen) {
      closeState();
      lenis.start();
      MicroModal.close('navigation');
    } else {
      header?.classList.add('is-open');
      hamburger.classList.add('is-open');
      lenis.stop();
      MicroModal.show('navigation', {
        onClose: () => {
          closeState();
          lenis.start();
        },
      });
    }
  }

  //リンククリックでモーダル閉じる処理(ロゴ・子メニュー・CV ボタンも対象)
  navigation.querySelectorAll('a[href]').forEach((link) => {
    link.addEventListener('click', () => {
      if (navigation.getAttribute('aria-hidden') === 'false') {
        closeState();
        lenis.start();
        MicroModal.close('navigation');
      }
    });
  });

  // 文字変更
  // function open(){
  //   txt.textContent = 'close';
  // }
  // function close(){
  //   txt.textContent = 'menu';
  // }
}

// ============================================
// drawer ハンバーガー開閉処理
// ============================================
function megaMenu() {
  const megaHeader = document.querySelector('.js-header');
  const links = document.querySelectorAll('.l-navigation__link');
  const targets = document.querySelectorAll('.l-navigation__link.js-popup-trigger');
  const popups = document.querySelectorAll('.l-navigation__item-child');
  if (links.length === 0 || targets.length === 0 || popups.length === 0) return;

  // メガメニュー展開状態をヘッダーに反映(文字色は CSS 側で制御)
  const setMegaState = (isOpen) => {
    megaHeader?.classList.toggle('is-mega-open', isOpen);
  };

  MicroModal.init();

  //リンクホバーでポップアップ削除
  const modalList = [];
  links.forEach((link) => {
    const id = link.getAttribute('aria-controls');
    if (id && document.getElementById(id)) {
      modalList.push(id);
    }
  });
  links.forEach((link) => {
    link.addEventListener(
      'pointerenter',
      () => {
        modalList.forEach((modalId) => {
          if (document.getElementById(modalId)?.classList.contains('is-open')) {
            MicroModal.close(modalId);
          }
        });
        links.forEach((link) => {
          link.classList.remove('is-open');
        });
        // 閉じた直後に開く場合は、続くトリガー側の pointerenter で再度 true になる
        setMegaState(false);
      },
      { passive: true }
    );
  });

  //ポップアップからマウス外れるとポップアップ削除
  popups.forEach((popup) => {
    popup.addEventListener(
      'pointerleave',
      () => {
        const id = popup.id;
        if (id) {
          MicroModal.close(id);
          document.querySelector(`[aria-controls="${CSS.escape(id)}"]`)?.classList.remove('is-open');
          setMegaState(false);
        }
      },
      { passive: true }
    );
  });

  //トリガーホバーでポップアップ登場
  targets.forEach((target) => {
    const id = target.getAttribute('aria-controls');
    const modal = id ? document.getElementById(id) : null;
    if (!modal) return;

    target.addEventListener(
      'pointerenter',
      () => {
        if (!modal.classList.contains('is-open')) {
          MicroModal.show(id);
          target.classList.add('is-open');
          setMegaState(true);
          modal.querySelector('.l-navigation__item-child-link')?.blur();
        }
      },
      { passive: true }
    );
  });
}

export { fixedHeader, switchHeaderLogo, drawer, megaMenu };
